import React from 'react';
import logo from '../../assets/images/limena/logolimena-ethnix.png';
function Loader() {
    return (
        <img src={logo} alt="logo" style={{width:220}} />
    );
}

export default Loader;
